import { useState } from "react";
import MainLayout from "../layout/MainLayout";
import SewaPayment from "../components/PaymentCollections/Sewa/SewaPayment";
import AirPayment from "../components/PaymentCollections/Air/AirPayment";

const PaymentCollectionReport = () => {

  const [type, setType] = useState('')

  return (
    <MainLayout>
    <div className="p-5">
      <label className="mb-3">Chose Client Type </label>
      <select className="mb-2 border w-full py-2 px-3 rounded-lg" onChange={(e) => setType(e.target.value)}>
        <option value=''>--Chose Client Type--</option>
        <option value='sewa' >Sewa</option>
        <option value='air'>Air</option>
      </select>

         {type === "sewa" && <SewaPayment/>}
         {type === "air" && <AirPayment/>}

    </div>
    </MainLayout>
  );
}
export default PaymentCollectionReport